import React from 'react';

const SimpleTest = () => {
  return (
    <div>
      <h1>✅ ROUTING WORKS!</h1>
      <p>If you can see this, React routing is working correctly.</p>
      <p>Current time: {new Date().toString()}</p>
    </div>
  );
};

export default SimpleTest;